import React from 'react';
import { TextField, TextFieldProps, Tooltip, IconButton } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

interface TextFieldWithInfoProps extends Omit<TextFieldProps, 'variant' | 'size'> {
  label: string;
  value: string | number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  tooltip?: string;
  variant?: 'standard' | 'filled' | 'outlined';
  size?: 'small' | 'medium';
  hideInfo?: boolean;
}

const TextFieldWithInfo: React.FC<TextFieldWithInfoProps> = ({
  label,
  value,
  onChange,
  tooltip,
  variant = 'outlined',
  size = 'small',
  hideInfo = false,
  ...textFieldProps
}) => {
  return (
    <FieldContainer>
      <TextField label={label} value={value} onChange={onChange} variant={variant} size={size} {...textFieldProps} />
      {!hideInfo && tooltip && (
        <StyledTooltip title={tooltip}>
          <InfoButton size="small">
            <FontAwesomeIcon icon={faInfoCircle} size="sm" />
          </InfoButton>
        </StyledTooltip>
      )}
    </FieldContainer>
  );
};

export default TextFieldWithInfo;

const FieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  .MuiTextField-root {
    flex: 1;
  }
`;

// Wrap Tooltip to allow styled-components to target popper + tooltip classes reliably
const StyledTooltip = styled(({ className, ...props }: any) => (
  <Tooltip {...props} classes={{ popper: className }} arrow />
))`
  .MuiTooltip-tooltip {
    font-size: 12px;
    max-width: 300px;
    background-color: #f7f7f7 !important; /* force light gray background */
    color: #555 !important; /* force gray text */
    border: 1px solid #ddd !important;
  }
  .MuiTooltip-arrow {
    color: #f7f7f7 !important; /* match background */
  }
`;

const InfoButton = styled(IconButton)`
  padding: 4px;
  color: #666;

  &:hover {
    color: #1976d2;
    background-color: rgba(25, 118, 210, 0.04);
  }
`;
